module.exports = __webpack_public_path__ + "6df29687bb386666a3bce3a194f1d2bd.png";